import React from "react";
import { UserCheckIcon } from "modules/icons";
import useStyles from "./styles";

type DeblockButtonProps = {
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  size?: "small" | "medium" | "big";
  title?: string;
};

export const DeblockButton: React.FC<DeblockButtonProps> = ({
  onClick,
  size = "medium",
  title,
}) => {
  const { classes, cx } = useStyles();

  const sizeClass =
    size === "small"
      ? classes.buttonSmall
      : size === "big"
      ? classes.buttonBig
      : classes.buttonMedium;

  return (
    <button
      title={title}
      className={cx(classes.deblockButton, classes.button, sizeClass)}
      onClick={(e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        onClick(e);
      }}
    >
      <span>
        <UserCheckIcon />
      </span>
    </button>
  );
};
